<template>
  <div class="admin-menu">
    <MenuBaseComponent :menu-properties="menuProperties" />
  </div>
</template>

<script>
import MenuBaseComponent from "@/components/navigation/menu/utils/MenuBaseComponent";
import {
  userDetailsAdmin, depsFunctionalities, gesFunctionalities, meFunctionalities,
  changeTable, validateAnnouncementsDeps, validateAnnouncementsMe, diavImport, activeReserve, kanonismoi
} from "@/config/menuopts"
export default {
  name: "AdminMenu",
  components: {MenuBaseComponent},
  data() {
    return {
      menuProperties: {
        userDetailsAdmin,
        gesFunctionalities,
        depsFunctionalities,
        meFunctionalities,
        changeTable,
        validateAnnouncementsDeps,
        validateAnnouncementsMe,
        activeReserve,
        diavImport,
        kanonismoi
      }
    }
  },
}
</script>

<style scoped>

</style>